import { Box, Checkbox, FormControlLabel, FormGroup, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import ReusableButton from './reusableButtonComponents';

const reasons = [
    'Not aligned with brand goals',
    'Past collaboration experience not satisfactory',
    "Content style doesn't match campaign tone",
    'Audience mismatch',
    "Other"
];

export default function RejectReason({ handleCheckboxChange, handleReject, setOtherMessage, selectedReasons, otherMessage, onClose }) {
    const [error, setError] = useState('');

    const onRejectClick = () => {
        if (selectedReasons.length === 0) {
            setError('Please select at least one reason for rejection.');
            return;
        }
        if (selectedReasons.includes('Other') && !otherMessage.trim()) {
            setError('Please specify the reason.');
            return;
        }

        setError('');
        handleReject();
    };
    return (
        <Box p={2}>
            <Box sx={{ borderBottom: "1px solid #E8E8E8", pb: 1 }}>
                <Typography sx={{ fontSize: '16px', fontWeight: 600, color: "#7A7A7A", }}>You are about to reject all application.</Typography>
            </Box>
            <Box>
                <Typography mt={1} mb={1} sx={{ fontSize: '14px', fontWeight: 600, color: "#7A7A7A" }}>
                    Reason for rejection *
                </Typography>
                <FormGroup>
                    {reasons.map((reason) => (
                        <FormControlLabel
                            key={reason}
                            control={
                                <Checkbox
                                    checked={selectedReasons.includes(reason)}
                                    onChange={() => handleCheckboxChange(reason)}
                                />
                            }
                            label={reason}
                        />
                    ))}
                </FormGroup>

                {selectedReasons.includes('Other') && (
                    <>
                        <Typography mt={1} sx={{ fontSize: '14px', fontWeight: 600, color: "#7A7A7A" }}>Other Reason</Typography>
                        <TextField
                            multiline
                            minRows={3}
                            fullWidth
                            placeholder="Please Specify..."
                            value={otherMessage}
                            onChange={(e) => setOtherMessage(e.target.value)}
                            sx={{ mt: 1, mb: 2 }}
                        />
                    </>
                )}
                {error && (
                    <Typography color="error" sx={{ fontSize: '13px', mt: 1 }}>
                        {error}
                    </Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-start', mb: 2, mt: 1 }}>
                <ReusableButton onClick={onClose} variant="outlined" children={"Cancel"} classNames={"gn-actionbtn-outline gn-actionbtn-color"} />
                <ReusableButton children={"Reject"} onClick={onRejectClick} variant="contained" classNames={"gn-actionbtn"} />
            </Box>
        </Box>
    )
}
